<template>
	<div ref="fadeIn" style="opacity: 0;">
        <slot></slot>
    </div>
</template>
​
<script>
import {gsap} from 'gsap';
import {ScrollTrigger} from 'gsap/ScrollTrigger';
gsap.registerPlugin(ScrollTrigger);
export default {
	mounted() {
        let vm = this;
        setTimeout(function(){
            vm.scroll();
        }, 500)

	},
    data() {
        return {
            visible: false
        }
    },
    methods: {
    	scroll() {
    		const wHeight = window.innerHeight;
            let tl = gsap.timeline();
            tl.to(this.$refs.fadeIn, {
                duration: 1,
                opacity: 1
            });

            ScrollTrigger.create({
                animation: tl,
                trigger: this.$refs.fadeIn, // start the animation when ".box" enters the viewport (once)
                start: 'start 80%',
                toggleActions: 'play complete resume reverse'
            });
    	}
    }
}
</script>